import React from "react";
import BtnGreen from "../BtnGreen";
import { setCurrentModal, toggleModal } from "@/store/slices/GlobalSlice";
import { useDispatch } from "react-redux";

const BtnShare = (props) => {
  const dispatch = useDispatch();

  const handleShare = () => {
    dispatch(toggleModal());
    dispatch(setCurrentModal("formWrapper"));
  };

  return (
    <figure className="absolute -bottom-1/2 left-1/2 transform -translate-x-1/2 w-full text-center">
      <BtnGreen
        className="border border-solid border-white"
        onClick={handleShare}
      >
        <span className="text-lg md:text-2xl">Share your Green Home</span>
        <span className="ml-5 mt-1">
          <img src={require("@/assets/images/right-arrow.png")} alt="icon" />
        </span>
      </BtnGreen>
    </figure>
  );
};

BtnShare.propTypes = {};

export default BtnShare;
